import theme from "../../theme";

const styles = {
  wrapper: {
    maxWidth: 500,
    background: theme.lightBackground,
    cursor: "pointer",
    minHeight: 300,
  },
  title: {
    color: theme.text.primary,
    fontSize: "2rem",
  },
  content: {
    color: theme.text.secondary,
  },
};

export default styles;
